<template>
  <CCard class="image-upload">
    <div class="text-center">
      <img :src="imageUrl" class="img-fluid" />
    </div>
    <CCardBody>
      <CCardTitle>{{ title }}</CCardTitle>
      <CCardText v-if="!!text">{{ text }}</CCardText>
      <CCardText class="text-right mt-1">
        <label class="btn btn-outline-primary">
          Alterar Imagem
          <input type="file" name="image" style="display: none;" accept="image/jpg, image/jpeg, image/png" @change="upload"/>
        </label>
      </CCardText>
    </CCardBody>
  </CCard>
</template>
<style scoped>
.image-upload:hover {
  border-color: #333;
}
</style>

<script>

export default {
  name: 'CardImage',
  props: [
    'title',
    'text',
    'upload',
    'imageUrl'
  ],
};
</script>